import { render, staticRenderFns } from "./ReductionPlanLayout.vue?vue&type=template&id=b774c538"
import script from "./ReductionPlanLayout.vue?vue&type=script&lang=js"
export * from "./ReductionPlanLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports